import React, { useCallback, useEffect, useState } from 'react'
import AccountDetailsTabs from './AccountDetailsTabs'
import { Form, Button } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
import api from '../../../services/api';
import useAuth from '../../../hooks/useAuth';
import { useDispatch } from 'react-redux';
import { fetchAccountDetailsRequest, fetchAccountInfoRequest } from '../../../store/features/actions/accountsActions';
import AccountDetailsTabsV2 from './AccountDetailsTabsV2';

export default function AccountDetails() {
   const dispatch = useDispatch();
   useAuth();
   const {user} = useUser()
   const navigate = useNavigate();

   const { accountId, accountName, clientName } = useParams();
   const [has_account_access, setHasAccountAccess] = useState(false)

   useEffect(() => {
      if (accountId &&  accountName && clientName) {
         const params = {
            page: 1,
            limit: 1,
            sort_by: "created_date",
            order: "asc",
            id: accountId,
          };
          // Check Account Access
          dispatch(fetchAccountInfoRequest({accountName,params}))
          dispatch(fetchAccountDetailsRequest(accountId, accountName, clientName)) 
      }
      
      // End: Check Account Access
   }, [accountId, accountName, clientName]);

   const checkAccountAccess = useCallback(async () => {
      try {
        
        if (accountName && user?.role_key === 'CLIENT') {
        

         const response = await api.get('/accounts/check_account_access', {
            params: {
              account_name: accountName,
            },
          });

         if(response.data.result.has_access === true){
            setHasAccountAccess(true)
         }else{
            setHasAccountAccess(false)
            sessionStorage.setItem('errorMessage', "Sorry. You don't have access for the account.");
            navigate('/dashboard');
         }
        }
      } catch (err) {
        console.log(err.message || "Failed to fetch events");
      }
    }, [accountId, accountName, clientName]);
  
    useEffect(() => {
      if(user?.role_key === 'CLIENT'){
         checkAccountAccess();
      }else{
         setHasAccountAccess(true)
      }
    }, [checkAccountAccess, user]);

   return (
         <div>
            
            <div className="account_details_wrapper">
            <div className='top_tabs_custom'>
                        <AccountDetailsTabsV2 />
                     </div>

               <div className='fixed_req_block'>
                  <h5 className='req_head'>Request Submitted!</h5>
                  <p className='req_para'>Thank you for subscribing. Your access request is being processed.</p>
                  <Button className="req_btn">
                     User Dashboard &nbsp;<i className="fa fa-arrow-right" aria-hidden="true"></i>
                  </Button>
               </div>




            </div>
         </div>
   )
}
